module.exports = __webpack_public_path__ + "img/purple-splash.23bd7012.png";